import { icon } from '../../icons';
import { type ReminderDto } from '../../services/api';
import { t } from '../../services/i18n';
import { esc } from './onboarding-shared';

export class RcOnboardingStepReminder extends HTMLElement {
  completionDestination: 'dashboard' | 'checkout' = 'dashboard';
  createdReminder: ReminderDto | null = null;

  render(): void {
    const threeMonths = new Date();
    threeMonths.setMonth(threeMonths.getMonth() + 3);
    const defaultDate = threeMonths.toISOString().split('T')[0];
    const existing = this.createdReminder;
    const isCheckoutCompletion = this.completionDestination === 'checkout';
    const completionMessage = isCheckoutCompletion
      ? t('onboarding.reminder.checkoutDescription')
      : t('onboarding.reminder.dashboardDescription');
    const finishLabel = isCheckoutCompletion
      ? t('onboarding.reminder.finishCheckout')
      : t('onboarding.reminder.finishDashboard');
    const skipLabel = isCheckoutCompletion
      ? t('onboarding.reminder.skipCheckout')
      : t('onboarding.skipStep');

    this.innerHTML = `
      <div class="wizard-step-content">
        <h1 class="wizard-step-title">${t('onboarding.reminder.title')}</h1>
        <p class="wizard-step-desc">${t('onboarding.reminder.description')}</p>
        <p class="wizard-step-desc wizard-step-desc-accent">${completionMessage}</p>
        <form id="wizard-form" class="wizard-form" novalidate>
          <div class="wizard-reminder-suggestions">
            <p class="wizard-suggestions-label">${t('onboarding.reminder.suggestionsLabel')}</p>
            <div class="wizard-suggestions-grid">
              <button type="button" class="wizard-suggestion" data-title="${t('onboarding.reminder.suggestion.epcTitle')}" data-days="90"><span class="wizard-suggestion-icon">90d</span> ${t('onboarding.reminder.suggestion.epcLabel')}</button>
              <button type="button" class="wizard-suggestion" data-title="${t('onboarding.reminder.suggestion.electricalTitle')}" data-days="180"><span class="wizard-suggestion-icon">180d</span> ${t('onboarding.reminder.suggestion.electricalLabel')}</button>
              <button type="button" class="wizard-suggestion" data-title="${t('onboarding.reminder.suggestion.insuranceTitle')}" data-days="365"><span class="wizard-suggestion-icon">365d</span> ${t('onboarding.reminder.suggestion.insuranceLabel')}</button>
              <button type="button" class="wizard-suggestion" data-title="${t('onboarding.reminder.suggestion.indexationTitle')}" data-days="365"><span class="wizard-suggestion-icon">365d</span> ${t('onboarding.reminder.suggestion.indexationLabel')}</button>
            </div>
          </div>
          <div class="form-group">
            <label for="w-rtitle">${t('common.title')} <span class="required">*</span></label>
            <input id="w-rtitle" name="title" type="text" required placeholder="${t('onboarding.reminder.titlePlaceholder')}" value="${existing ? esc(existing.title) : ''}">
          </div>
          <div class="form-group">
            <label for="w-rdate">${t('common.deadline')} <span class="required">*</span></label>
            <input id="w-rdate" name="dueDate" type="date" required value="${existing?.dueDate ?? defaultDate}">
          </div>
          <div id="wizard-error" class="wizard-error" style="display:none"></div>
          <div class="wizard-actions">
            <button type="button" class="btn btn-outline wizard-prev-btn">
              ${icon('arrow-left', { size: 16, strokeWidth: 2.5 })}
              ${t('common.previous')}
            </button>
            <div class="wizard-actions-right">
              <button type="button" class="btn btn-outline wizard-skip-btn">${skipLabel}</button>
              <button type="submit" class="btn btn-primary btn-lg wizard-next-btn" id="finish-btn">
                ${finishLabel}
                ${icon('check', { size: 16, strokeWidth: 2.5 })}
              </button>
            </div>
          </div>
        </form>
      </div>
    `;

    this.querySelector('.wizard-prev-btn')?.addEventListener('click', () => this.dispatchEvent(new CustomEvent('onboarding-prev', { bubbles: true })));
    this.querySelector('.wizard-skip-btn')?.addEventListener('click', () => this.dispatchEvent(new CustomEvent('onboarding-skip', { bubbles: true })));
    this.querySelectorAll<HTMLButtonElement>('.wizard-suggestion').forEach((button) => {
      button.addEventListener('click', () => {
        const titleInput = this.querySelector<HTMLInputElement>('#w-rtitle');
        const dateInput = this.querySelector<HTMLInputElement>('#w-rdate');
        if (titleInput) titleInput.value = button.dataset.title || '';
        if (dateInput && button.dataset.days) {
          const date = new Date();
          date.setDate(date.getDate() + parseInt(button.dataset.days, 10));
          dateInput.value = date.toISOString().split('T')[0];
        }
        this.querySelectorAll('.wizard-suggestion').forEach((item) => item.classList.remove('selected'));
        button.classList.add('selected');
      });
    });
    this.querySelector<HTMLFormElement>('#wizard-form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.dispatchEvent(new CustomEvent('onboarding-submit', {
        bubbles: true,
        detail: { form: event.currentTarget as HTMLFormElement },
      }));
    });
  }
}

if (!customElements.get('rc-onboarding-step-reminder')) {
  customElements.define('rc-onboarding-step-reminder', RcOnboardingStepReminder);
}
